module.exports = __webpack_public_path__ + "static/media/icon-institutional.91951062.svg";